module.exports = __webpack_public_path__ + "img/logo.700aecfb.png";